import React from "react";

function NavWrapper({ children }) {
  return <div className="it-nav-wrapper">{children}</div>;
}

export default NavWrapper;
